__turbopack_context__.v({
  "brandContainer": "BrandDetail-module__cySeYG__brandContainer",
  "categoryTags": "BrandDetail-module__cySeYG__categoryTags",
  "contentCard": "BrandDetail-module__cySeYG__contentCard",
  "contentSection": "BrandDetail-module__cySeYG__contentSection",
  "contentSections": "BrandDetail-module__cySeYG__contentSections",
  "emptyProducts": "BrandDetail-module__cySeYG__emptyProducts",
  "faqItem": "BrandDetail-module__cySeYG__faqItem",
  "faqItemAnswer": "BrandDetail-module__cySeYG__faqItemAnswer",
  "faqItemHeader": "BrandDetail-module__cySeYG__faqItemHeader",
  "faqItemIcon": "BrandDetail-module__cySeYG__faqItemIcon",
  "faqItemIconExpanded": "BrandDetail-module__cySeYG__faqItemIconExpanded",
  "faqItemQuestion": "BrandDetail-module__cySeYG__faqItemQuestion",
  "faqSection": "BrandDetail-module__cySeYG__faqSection",
  "heroBadge": "BrandDetail-module__cySeYG__heroBadge",
  "heroBadgeIcon": "BrandDetail-module__cySeYG__heroBadgeIcon",
  "heroBadges": "BrandDetail-module__cySeYG__heroBadges",
  "heroDescription": "BrandDetail-module__cySeYG__heroDescription",
  "heroImage": "BrandDetail-module__cySeYG__heroImage",
  "heroSection": "BrandDetail-module__cySeYG__heroSection",
  "heroText": "BrandDetail-module__cySeYG__heroText",
  "pageWrapper": "BrandDetail-module__cySeYG__pageWrapper",
  "productsSection": "BrandDetail-module__cySeYG__productsSection",
  "reasonCard": "BrandDetail-module__cySeYG__reasonCard",
  "reasonText": "BrandDetail-module__cySeYG__reasonText",
  "reasonTitle": "BrandDetail-module__cySeYG__reasonTitle",
  "reasonsList": "BrandDetail-module__cySeYG__reasonsList",
  "regionTag": "BrandDetail-module__cySeYG__regionTag",
  "regionTags": "BrandDetail-module__cySeYG__regionTags",
  "relatedBrandsContainer": "BrandDetail-module__cySeYG__relatedBrandsContainer",
  "relatedBrandsTitle": "BrandDetail-module__cySeYG__relatedBrandsTitle",
  "sectionText": "BrandDetail-module__cySeYG__sectionText",
  "sectionTitle": "BrandDetail-module__cySeYG__sectionTitle",
  "sectionTitleLeft": "BrandDetail-module__cySeYG__sectionTitleLeft",
  "sectionTitleSpaced": "BrandDetail-module__cySeYG__sectionTitleSpaced",
  "stepIndicator": "BrandDetail-module__cySeYG__stepIndicator",
  "stepLine": "BrandDetail-module__cySeYG__stepLine",
  "stepNumber": "BrandDetail-module__cySeYG__stepNumber",
  "stepRow": "BrandDetail-module__cySeYG__stepRow",
  "stepText": "BrandDetail-module__cySeYG__stepText",
  "stepTextSpaced": "BrandDetail-module__cySeYG__stepTextSpaced",
  "stepsContainer": "BrandDetail-module__cySeYG__stepsContainer",
});
